module.exports = __webpack_public_path__ + "img/business_license_upload.06382ed7.png";